/** @format */

import NumberFormat from 'react-number-format';
import React from 'react';

/**
 * Because I'm tired of typing this
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function Currency({className = 'tw-text-lg', ...props}) {
    const defaults = {
        displayType: 'text',
        prefix: '$',
        decimalScale: 0,
        fixedDecimalScale: true,
        thousandSeparator: true
    };

    return <NumberFormat {...defaults} {...props} className={`${className}`} />;
}
